import React from 'react';

const BannerIcon = () => (
  <svg aria-hidden fill="none" height="65" viewBox="0 0 53 65" width="53" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3452_19082)">
      <path d="M5 45.5V1H48V45.5L27.0658 56L5 45.5Z" stroke="currentColor" fill="currentColor" />
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="64.0564"
        id="filter0_d_3452_19082"
        width="52"
        x="0.5"
        y="0.5"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_3452_19082" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_3452_19082" mode="normal" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default BannerIcon;
